// In src/Feedback.js

import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, query, onSnapshot, orderBy } from "firebase/firestore";
import { FaStar } from 'react-icons/fa';

// A simple component to display star ratings
const StarRating = ({ rating }) => (
    <div className="flex">
        {[...Array(5)].map((_, index) => (
            <FaStar key={index} color={index < rating ? '#ffc107' : '#e4e5e9'} />
        ))}
    </div>
);

export default function Feedback() {
    const [feedback, setFeedback] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const q = query(collection(db, "feedback"), orderBy("submittedAt", "desc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setFeedback(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    if (loading) return <p className="loading-text">Loading feedback...</p>;

    return (
        <div className="card">
            <h2 className="page-header">User & Driver Feedback</h2>
            <p className="page-subheader">Review feedback submitted from the website and driver accounts.</p>
            
            <table className="table">
                <thead>
                    <tr>
                        <th>Rating</th>
                        <th>Category</th>
                        <th>User</th>
                        <th>Description</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {feedback.map(item => (
                        <tr key={item.id}>
                            <td><StarRating rating={item.rating} /></td>
                            <td>{item.category}</td>
                            <td>
                                {item.isDriver ? (
                                    <span className="status-badge status-driver">Driver</span>
                                ) : (
                                    <span className="status-badge status-public">Public</span>
                                )}
                                <p className="text-sm">{item.driverInfo?.email || item.driverInfo?.name}</p>
                            </td>
                            <td className="description-cell">{item.description}</td>
                            <td>{item.submittedAt?.toDate().toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}